import { SvgIcon, SvgIconProps } from '@mui/material';

export function BookOpenOutlineIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.1833 3.51631C17.0865 3.43799 16.9734 3.38237 16.8523 3.35353C16.7311 3.32468 16.6051 3.32336 16.4833 3.34964L10 4.80797L3.51667 3.33297C3.39303 3.30505 3.26464 3.3057 3.14128 3.33487C3.01793 3.36405 2.90285 3.42098 2.80482 3.50134C2.70678 3.5817 2.62837 3.68336 2.57555 3.79859C2.52273 3.91382 2.49689 4.03958 2.50001 4.16631V14.333C2.4953 14.5256 2.55749 14.7139 2.67601 14.8659C2.79452 15.0178 2.96202 15.124 3.15001 15.1663L9.81667 16.6663H10.1833L16.85 15.1663C17.038 15.124 17.2055 15.0178 17.324 14.8659C17.4425 14.7139 17.5047 14.5256 17.5 14.333V4.16631C17.4994 4.04114 17.4707 3.9177 17.4158 3.80517C17.361 3.69265 17.2816 3.59391 17.1833 3.51631ZM4.16667 5.20797L9.16667 6.33297V14.7913L4.16667 13.6663V5.20797ZM15.8333 13.6663L10.8333 14.7913V6.33297L15.8333 5.20797V13.6663Z'
        fill={fill}
      />
    </SvgIcon>
  );
}
